'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTransitionGroupCSSTransitionGroup = require('react-transition-group/CSSTransitionGroup');

var _reactTransitionGroupCSSTransitionGroup2 = _interopRequireDefault(_reactTransitionGroupCSSTransitionGroup);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var PanelBody = (function (_React$Component) {
  _inherits(PanelBody, _React$Component);

  function PanelBody(props) {
    _classCallCheck(this, PanelBody);

    _get(Object.getPrototypeOf(PanelBody.prototype), 'constructor', this).call(this, props);
  }

  _createClass(PanelBody, [{
    key: 'renderPanelBody',
    value: function renderPanelBody() {
      var _props = this.props;
      var isOpen = _props.isOpen;
      var type = _props.type;
      var className = _props.className;
      var children = _props.children;

      var rest = _objectWithoutProperties(_props, ['isOpen', 'type', 'className', 'children']);

      if (!isOpen) return false;

      return _react2['default'].createElement(
        'div',
        _extends({ className: (0, _classnames2['default'])('PanelBody', 'PanelBody-' + type, className) }, rest),
        children
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props;
      var className = _props2.className;
      var type = _props2.type;

      return _react2['default'].createElement(
        _reactTransitionGroupCSSTransitionGroup2['default'],
        {
          'data-modal': 'true',
          className: className,
          transitionName: 'PanelBody-' + type,
          transitionEnterTimeout: 350,
          transitionLeaveTimeout: 350,
          component: 'div'
        },
        this.renderPanelBody()
      );
    }
  }]);

  return PanelBody;
})(_react2['default'].Component);

PanelBody.propTypes = {
  isOpen: _propTypes2['default'].bool.isRequired,
  className: _propTypes2['default'].string,
  style: _propTypes2['default'].object,
  type: _propTypes2['default'].oneOf(['default', 'collapsible'])
};

PanelBody.defaultProps = {
  isOpen: true,
  type: 'default'
};

module.exports = PanelBody;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/PanelBody.js
// module id = 464
// module chunks = 0